import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'components/Link'
import { Container } from 'components/Grid'

import Wrapper from './Wrapper'
import Title from './Title'
import Navigation from './Navigation'
import NavItem from './NavItem'

const Header = ({ siteTitle }) => (
  <Wrapper as="header">
    <Container maxWidth="800px">

      <Navigation>
        <NavItem>
          <Link to="/">Home</Link>
        </NavItem>
        <NavItem>
          <Link to="/blog">Blog</Link>
        </NavItem>
        <Title>
          <Link to="/">{siteTitle}</Link>
        </Title>
        <NavItem>
          <Link to="/broekenfilter">Broeken filter</Link>
        </NavItem>
        <NavItem>
          <Link to="/positives">Positives</Link>
        </NavItem>
      </Navigation>
    </Container>
  </Wrapper>
)

Header.propTypes = {
  siteTitle: PropTypes.string.isRequired,
}

export default Header
